import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import InfiniteScroll from 'react-infinite-scroll-component';
import LinearProgress from "@material-ui/core/LinearProgress";
import FeedItem from "./FeedItem";
import request from "../../../../../Services/API/Requests";
import LikedList from "./LikedList";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import './Feed.css'
import {creatingFilter} from "../ListScreenComponent/List/Utils/creatingFilter";
import {getSafe} from "../../../Utils";
import {useDispatch, useSelector} from "react-redux";
import {setRefreshDataFalse} from "../../../jsonScreen.slice";

const useStyles = makeStyles(() => ({
    container: {
        height: '100%',
        overflow: 'auto',
        width: '100%'
    }
}));

const isOpenLIkeListDefaultState = {
    open: false,
    feedId: null
};

const Feed = ({component, doActions, globalValues}) => {
    const [data, setData] = useState({content: [], totalPages: 0});
    const [filter, setFilter] = useState([]);
    const [entity, setEntity] = useState([]);
    const [activeUsers, setActiveUsers] = useState([]);
    const [pagination, setPagination] = useState({page: 0, pageSize: 5});
    const [isOpenLikeList, setIsOpenLikeList] = useState(isOpenLIkeListDefaultState);
    const dispatch = useDispatch();
    const {refreshData} = useSelector(state => state.jsonScreen)
    const classes = useStyles();
    const userId = globalValues ? getSafe(() => globalValues.session.user.id, '') : '';
    const styles = component.styles ? component.styles[0] : {};
    const properties = component.properties || {};
    const events = component.events || [];
    const isRefreshData = findByString(refreshData, 'Feed Component');

    useEffect(() => {
        if (events.length) {
            const event = events[0] || {};
            if (event.event === 'onLoad') {
                if (event.actions && event.actions.length) {
                    if (event.actions[0].type === 'setFilter') {
                        const filter = creatingFilter(event.actions[0], {}, '')
                        setFilter(filter)
                        return
                    }
                }
            }
        }
        getData(pagination.page)
    }, [])

    useEffect(() => {
        if (isRefreshData) {
            refreshFeed();
            dispatch(setRefreshDataFalse(properties.list ? properties.list : "feedDefaultList"));
        }
    }, [isRefreshData]);
    useEffect(() => {
        filter.length && getData(pagination.page)
    }, [JSON.stringify(filter)])

    async function getData(page) {
        const list = await request({
            url: 'list/read',
            data: {
                id: properties.list ? properties.list : "feedDefaultList",
            }
        })
        const entity = getSafe(() => list.source.inPlaceConnection.connectionDetails.entity, 'feed');
        const response = await request({
            url: "list/getData",
            data: {
                id: properties.list ? properties.list : "feedDefaultList",
                pageSize: 5,
                pageNumber: page,
                advancedFilter: filter
            }
        });
        setData(prevState => ({
            ...response,
            content: prevState.content.concat(response.content)
        }));
        setEntity(entity)
    }

    async function refreshFeed() {
        const response = await request({
            url: "list/getData",
            data: {
                id: properties.list ? properties.list : "feedDefaultList",
                pageSize: (pagination.page + 1) * 5,
                pageNumber: 0
            }
        });
        setData({...response, content: response.content});
    }

    function loadMore() {
        if (pagination.page * pagination.pageSize <= data.totalElements) {
            setPagination(prevState => ({
                ...prevState,
                page: prevState.page + 1
            }));
            getData(pagination.page + 1)
        }
    }

    function onOpenLikeList(feedId) {
        setIsOpenLikeList({
            open: true,
            feedId
        })
    }

    function onCloseLikeList() {
        setIsOpenLikeList(isOpenLIkeListDefaultState)
    }

    function openFeedPost(feedId) {
        const action = [{
            type: 'nextScreen',
            destination: 'feedPost/{id}',
            param: [
                {tag: 'id', value: ['{id}']},
                {tag: 'entity', value: [entity]}
            ]
        }];
        doActions(action, {id: feedId})
    }

    function editFeedPost(feedId) {
        const action = [{
            type: 'nextScreen',
            destination: `/${entity}/{id}`,
            param: [
                {tag: 'id', value: ['{id}']},
                {tag: 'entity', value: [entity]}
            ]
        }];
        console.log(action)
        doActions(action, {id: feedId})
    }

    async function onClickLike(id) {
        try {
            const response = await request({
                url: `${entity}/like`,
                data: {id}
            });
            setData(prevData => (
                {
                    ...prevData,
                    content: prevData.content.map(i => (
                        i.id === response.id ?
                            {...i, like: response.like} : i
                    )),
                }
            ));
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div
            className={classes.container}
            style={{
                width: styles.width,
                height: styles.height
            }}
            id={'feedContainer'}
        >
            <InfiniteScroll
                dataLength={data.content.length}
                next={loadMore}
                hasMore={data.totalPages - 1 > pagination.page}
                loader={<LoadMore/>}
                scrollableTarget={'feedContainer'}
            >
                {data.content.map(item => {
                    return (
                        <div key={item.id} style={{height: 'auto'}}>
                            <FeedItem
                                item={item}
                                userId={userId}
                                onClickLikeNumber={() => onOpenLikeList(item.id)}
                                openFeedPost={() => openFeedPost(item.id)}
                                editFeedPost={() => editFeedPost(item.id)}
                                onClickLike={() => onClickLike(item.id)}
                            />
                        </div>
                    )
                })}
            </InfiniteScroll>
            <LikedList
                onClose={onCloseLikeList}
                open={isOpenLikeList.open}
                feedId={isOpenLikeList.feedId}
                entity={entity}
            />
        </div>
    )
};

export default JsonScreenHoc(Feed);

Feed.propTypes = {
    component: PropTypes.object
};
Feed.defaultProps = {
    doActions: () => {
    },
    component: {}
};

const LoadMore = () => {
    return (
        <div>
            <LinearProgress/>
        </div>
    )
};


// import React, {useEffect, useRef, useState} from 'react';
// import PropTypes from 'prop-types';
// import makeStyles from "@material-ui/core/styles/makeStyles";
// import InfiniteScroll from 'react-infinite-scroll-component';
// import LinearProgress from "@material-ui/core/LinearProgress";
// import FeedItem from "./FeedItem";
// import LoadingItem from "./LoadingItem";
// import request from "../../../../../Services/API/Requests";
// import './Feed.css'
// import LikedList from "./LikedList";
// import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
// import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
// import {VariableSizeList as List} from "react-window";
// import Autosizer from "react-virtualized-auto-sizer";
//
// const useStyles = makeStyles(() => ({
//     container: {
//         height: '100%',
//         overflow: 'auto',
//         width: '100%'
//     }
// }));
//
// const isOpenLIkeListDefaultState = {
//     open: false,
//     feedId: null
// };
// //TODO
// // 1. add wrapper of react-window component
// // 2. connect hook with pagination,
// const Feed = ({component, doActions, globalValues, refreshData, setRefreshDataFalse}) => {
//     const [data, setData] = useState({content: [], totalPages: 0});
//     const [activeUsers, setActiveUsers] = useState([]);
//     const [pagination, setPagination] = useState({page: 0, pageSize: 5});
//     const [isOpenLikeList, setIsOpenLikeList] = useState(isOpenLIkeListDefaultState);
//     const classes = useStyles();
//     const userId = globalValues ? globalValues.session.user.id : '';
//     const styles = component.styles ? component.styles[0] : {};
//     const properties = component.properties || {};
//     const isRefreshData = findByString(refreshData, 'Feed Component');
//     const listRef = useRef({});
//     const rowHeights = useRef({});
//     useEffect(() => {
//         getData()
//     }, [pagination.page]);
//     useEffect(() => {
//         if(isRefreshData) {
//             refreshFeed();
//             setRefreshDataFalse();
//         }
//     }, [isRefreshData]);
//
//     async function getData() {
//         const response = await request({
//             url: "list/getData",
//             data: {
//                 id: properties.list ? component.properties.list : "feedDefaultList" ,
//                 pageSize: 5,
//                 pageNumber: pagination.page
//             }
//         });
//         setData(prevState => ({
//             ...response,
//             content: prevState.content.concat(response.content)
//         }));
//     }
//
//     async function refreshFeed() {
//         const response = await request({
//             url: "list/getData",
//             data: {
//                 id: "feedDefaultList",
//                 pageSize: (pagination.page + 1) * 5,
//                 pageNumber: 0
//             }
//         });
//         setData({...response, content: response.content});
//     }
//
//     function loadMore() {
//         if (pagination.page * pagination.pageSize <= data.totalElements) {
//             setPagination(prevState => ({
//                 ...prevState,
//                 page: prevState.page + 1
//             }));
//         }
//     }
//
//     function onOpenLikeList(feedId) {
//         setIsOpenLikeList({
//             open: true,
//             feedId
//         })
//     }
//
//     function onCloseLikeList() {
//         setIsOpenLikeList(isOpenLIkeListDefaultState)
//     }
//
//     function openFeedPost(feedId) {
//         const action = [{
//             type: 'nextScreen',
//             destination: 'feedPost/{id}',
//             param: [
//                 {tag: 'id', value: ['{id}']}
//             ]
//         }];
//         doActions(action, {id: feedId})
//     }
//
//     function editFeedPost(feedId) {
//         const action = [{
//             type: 'nextScreen',
//             destination: 'feed/{id}',
//             param: [
//                 {tag: 'id', value: ['{id}']}
//             ]
//         }];
//         doActions(action, {id: feedId})
//     }
//
//     async function onClickLike(id) {
//         try {
//             const response = await request({
//                 url: 'feed/like',
//                 data: {id}
//             });
//             setData(prevData => (
//                 {
//                     ...prevData,
//                     content: prevData.content.map(i => (
//                         i.id === response.id ?
//                             {...i, like: response.like} : i
//                     )),
//                 }
//             ));
//         } catch (e) {
//             console.log(e)
//         }
//     }
//
//     function getRowHeight(index) {
//         return rowHeights.current[index];
//     }
//     function setRowHeight(index, size) {
//         listRef.current.resetAfterIndex(0);
//         // listRef.current.resetAfterColumnIndex({columnIndex:0})
//         rowHeights.current = {...rowHeights.current, [index]: size};
//     }
//     function Row({index, style}) {
//         const item = data.content[index];
//         const rowRef = useRef({});
//         useEffect(() => {
//             if (rowRef.current) {
//                 setRowHeight(index, rowRef.current.clientHeight);
//             }
//         }, [rowRef]);
//         return(
//             <div key={item.id} style={{...style}} ref={rowRef}>
//                 <FeedItem
//                     item={item}
//                     userId={userId}
//                     onClickLikeNumber={() => onOpenLikeList(item.id)}
//                     openFeedPost={() => openFeedPost(item.id)}
//                     editFeedPost={() => editFeedPost(item.id)}
//                     onClickLike={() => onClickLike(item.id)}
//                 />
//             </div>
//         )
//     }
//     return (
//         <div
//             className={classes.container}
//             style={{
//                 width: styles.width,
//                 height: styles.height
//             }}
//             id={'feedContainer'}
//         >
//             <Autosizer>
//                 {({height, width}) => (
//                     <List
//                         ref={listRef}
//                         height={height}
//                         width={width}
//                         itemCount={data.content.length}
//                         itemSize={index => getRowHeight(index)}
//                     >
//                         {Row}
//                     </List>
//                 )}
//             </Autosizer>
//
//             <LikedList
//                 onClose={onCloseLikeList}
//                 open={isOpenLikeList.open}
//                 feedId={isOpenLikeList.feedId}
//             />
//         </div>
//     )
// };
//
// export default JsonScreenHoc(Feed);
//
// Feed.propTypes = {
//     component: PropTypes.object
// };
// Feed.defaultProps = {
//     doActions: () => {},
//     component: {}
// };
//
// const LoadMore = ({isLoading}) => {
//     return (
//         <div>
//             <LinearProgress/>
//         </div>
//     )
// };